import { z } from "zod";

export const ChecklistItemEntregaCadastroSchema = z.object({
    idItemChecklistEntrega: z.number().int().optional(),
    ordem: z.string().nonempty({ message: "A ordem é obrigatória." }),
    descricao: z.string().nonempty({ message: "A descrição é obrigatória." }),

});

export type ChecklistItemEntregaCadastroForm = z.infer<typeof ChecklistItemEntregaCadastroSchema>;

export const defaultChecklistItemEntregaCadastroForm: Partial<ChecklistItemEntregaCadastroForm> = {
    idItemChecklistEntrega: undefined,
    ordem: undefined,
    descricao: undefined,

};
